import React from 'react'

// components

import CardStore from 'components/Cards/CardStore.js'

export default function CreateStore() {
    return (
        <>
            <div className="flex flex-wrap">
                <div className="w-full lg:w-12 px-4">
                    <CardStore />
                </div>
            </div>
        </>
    )
}
